// Import auth service for authenticated requests
import { authService } from './authService';
import { getServerURL } from './config';

const SERVER_URL = getServerURL();

export const previewersService = {
  // Get all previewers
  async getAllPreviewers(params = {}) {
    if (!SERVER_URL) {
      console.error('SERVER_URL is not configured');
      throw new Error('API server URL is not configured');
    }
    try {
      const {
        page = 1,
        limit = 20,
        status,
        story_slug,
        generation_id,
        kid_name,
        q,
      } = params;

      const searchParams = new URLSearchParams();
      if (page) searchParams.set('page', String(page));
      if (limit) searchParams.set('limit', String(limit));
      if (status && status !== 'all') searchParams.set('status', status);
      if (story_slug) searchParams.set('story_slug', story_slug);
      if (generation_id) searchParams.set('generation_id', generation_id);
      if (kid_name) searchParams.set('kid_name', kid_name);
      if (q) searchParams.set('q', q);

      const url = `${SERVER_URL}/previews${searchParams.toString() ? `?${searchParams.toString()}` : ''}`;

      const response = await fetch(url, {
        headers: authService.getAuthHeaders(),
      });
      if (response.ok) {
        const data = await response.json();
        // Return the full response object to include pagination metadata
        return data;
      } else {
        console.error('API Error:', response.status, response.statusText);
        throw new Error(`Failed to fetch previewers: ${response.status}`);
      }
    } catch (error) {
      console.error('Error fetching previewers:', error);
      return {
        success: false,
        total: 0,
        count: 0,
        page: 1,
        limit: 20,
        pageCount: 0,
        hasNext: false,
        hasPrev: false,
        database: 'PreviewerStories',
        collection: 'Previews',
        data: [],
      };
    }
  },
}; 